import React, { Dispatch } from "react";
import { BootstrapEntity } from "../../services/Bootstrap/bootstrap.entity";
import { ActionType } from "./types";
import { MenuDetail } from "./usecase.d";

export type LoginModeType = "LoggedIn" | "Guest";

export type SettingStateType = {
  menuDetail?: MenuDetail;
  tenantInfo?: BootstrapEntity;
  loginMode?: LoginModeType;
};

export type SettingActionType = {
  type: symbol;
  menuDetail?: MenuDetail;
  tenantInfo?: BootstrapEntity;
  loginMode?: LoginModeType;
};

type SettingReducerType = React.Reducer<SettingStateType, SettingActionType>;

export type SettingDispatch = Dispatch<SettingActionType>;

const initialGetState: SettingStateType = {};

export const Reducer: SettingReducerType = (
  state = initialGetState,
  action,
) => {
  switch (action.type) {
    case ActionType.SetMenuDetail:
      return {
        ...state,
        menuDetail: action.menuDetail,
      };
    case ActionType.SetTenantInfo:
      return {
        ...state,
        tenantInfo: action.tenantInfo,
      };
    case ActionType.SetLoginMode:
      return {
        ...state,
        loginMode: action.loginMode,
      };
    default:
      return state;
  }
};
